<template>
    <div class="card dashboard-card sm-radius no-label-chart donut-table-chart">
        <div v-show="!noRecordFound && !showSpinner" class="row">
            <div class="col-lg-6">
                <div class="dashboard-charts donut-tale-graph">
                    <h2 class="heading">
                        {{ heading }}
                    </h2>
                    <!-- customers by age group -->

                    <div
                        :id="id"
                        class="amcharts-div customers-by-nationality"
                    ></div>
                    <div class="chart-highest-record">
                        <h2>{{ graphHeading }}</h2>
                        <p>
                            {{ maximum ? maximum.group : '' }}
                            <strong>{{ maximum ? maximum.count : '' }}</strong>
                            ({{ maximum ? maximum.percentage : '' }})
                        </p>
                    </div>
                    <!-- customers by age group end-->
                </div>
            </div>

            <div class="col-lg-6 col-print-6 mb-370-print">
                <div id="style-2" class="table-scroll">
                    <div class="inner">
                        <div
                            :id="legendId"
                            class="custom-legend-wrapper table-style cols-full"
                        ></div>
                    </div>
                </div>
            </div>
        </div>
        <base-table-spinner v-show="showSpinner"></base-table-spinner>
        <base-no-record-found v-show="noRecordFound"></base-no-record-found>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import resource from '@/api/resource'
import _ from 'lodash'
// import AmCharts from 'amcharts3'
// import AmSerial from 'amcharts3/amcharts/serial'
// import AmPie from 'amcharts3/amcharts/pie'
export default {
    // End of Component > watch
    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {
        id: {
            type: String,
            default: null,
        },
        legendId: {
            type: String,
            default: null,
        },
        graphHeading: {
            type: String,
            default: null,
        },
        path: {
            type: String,
            required: true,
        },
        query: {
            type: Object,
            required: true,
        },
        reset: {
            type: Number,
        },
    },
    data() {
        return {
            titleField: null,
            valueField: null,
            percents: null,
            dataProvider: [],

            resourceApi: null,
            noRecordFound: false,
            showSpinner: true,
        }
    },
    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {
        reset(value) {
            if (value) {
                this.getStats()
            }
        },
        dataSegmentId(value) {
            if (value) {
                this.noRecordFound = false
                this.showSpinner = true
                this.getStats()
            }
        },
    }, // End of Component > props
    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['dataSegmentId']),
        heading() {
            return _.startCase(this.id)
        },
        maximum() {
            return _.maxBy(this.dataProvider, 'count')
        },
    }, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {
        this.getStats()
    }, // End of Component > mounted
    /*
    |--------------------------------------------------------------------------
    | Component > created
    |--------------------------------------------------------------------------
    */
    created() {
        let api = new resource(this.path)
        this.resourceApi = api
    }, // End of Component > computed
    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        async getStats() {
            try {
                this.dataProvider = []
                this.query.dataSegmentId = this.dataSegmentId
                    ? this.dataSegmentId
                    : localStorage.getItem('activeDataSegmentId')
                let { data } = await this.resourceApi.list(this.query)
                this.showSpinner = false

                if (data && data.data) {
                    if (data.data.length) {
                        this.titleField = 'group'
                        this.valueField = 'count'
                        this.percents = 'percentage'
                        this.dataProvider = data.data
                    } else {
                        this.noRecordFound = true
                    }
                } else {
                    this.noRecordFound = true
                }
                await this.created()
            } catch (error) {
                this.$store.commit('setError', error)
            }
        },
        created() {
            let self = this

            window.AmCharts.makeChart(self.id, {
                type: 'pie',
                innerRadius: '80%',
                colors: [
                    '#7f1ec5',
                    '#00a4f2',
                    '#00c535',
                    '#eb8300',
                    '#f4c200',
                    '#c1c1c1',
                    '#F8508C',
                    '#00b1a5',
                    '#84dc2b',
                    '#5172fa',
                    '#798bb0',
                    '#b31493',
                    '#7000f7',
                    '#4a005e',
                    '#a388b0',
                    '#770d42',
                    '#388b79',
                    '#fc7400',
                    '#ff87e6',
                    '#f8e08e',
                    '#7f1ec5',
                    '#00a4f2',
                    '#00c535',
                    '#eb8300',
                    '#f4c200',
                    '#c1c1c1',
                    '#F8508C',
                    '#00b1a5',
                    '#84dc2b',
                    '#5172fa',
                    '#798bb0',
                    '#b31493',
                    '#7000f7',
                    '#4a005e',
                    '#a388b0',
                    '#770d42',
                    '#388b79',
                    '#fc7400',
                    '#ff87e6',
                    '#f8e08e',
                    '#7f1ec5',
                    '#00a4f2',
                    '#00c535',
                    '#eb8300',
                    '#f4c200',
                    '#c1c1c1',
                    '#F8508C',
                    '#00b1a5',
                    '#84dc2b',
                    '#5172fa',
                    '#798bb0',
                    '#b31493',
                    '#7000f7',
                    '#4a005e',
                    '#a388b0',
                    '#770d42',
                    '#388b79',
                    '#fc7400',
                    '#ff87e6',
                    '#f8e08e',
                ],
                labelsEnabled: false,
                pullOutRadius: '0%',
                balloonText: '[[title]]: <b>[[value]]</b> [[percents]]%',
                marginBottom: 0,
                marginTop: 0,
                outlineAlpha: 1,
                outlineThickness: 2,
                titleField: this.titleField,
                valueField: this.valueField,
                color: '#1B1B1E',
                fontFamily: 'ProximanovaRegular',
                fontSize: 14,
                allLabels: [],
                balloon: {
                    color: '#1B1B1E',
                    fillAlpha: 1,
                },
                titles: [],
                dataProvider: this.dataProvider,
                export: {
                    enabled: true,
                    libs: {
                        path: '../libs/',
                    },
                    menu: [],
                },
                listeners: [
                    {
                        event: 'init',
                        method: function (event) {
                            // chart initialized
                            // let's build a custom legend
                            var chart = event.chart

                            // get legend object

                            var legend = document.getElementById(this.legendId)
                            document.getElementById(this.legendId).innerHTML =
                                ''
                            // cycle through the data
                            for (
                                var i = 0;
                                i < chart.dataProvider.length;
                                i++
                            ) {
                                // data point

                                var dp = chart.dataProvider[i]
                                // create a legend item holder
                                var item = document.createElement('div')

                                // create marker
                                var marker = document.createElement('div')
                                marker.className = 'legend-marker'
                                marker.style.backgroundColor = chart.colors[i]
                                item.appendChild(marker)

                                // create title
                                var title = document.createElement('div')
                                title.className = 'legend-title'
                                title.innerHTML = dp.group
                                item.appendChild(title)

                                // create absolute value
                                var value = document.createElement('div')
                                value.className = 'legend-value'
                                value.innerHTML = dp.percentage
                                item.appendChild(value)

                                // users from each country
                                var users = document.createElement('div')
                                users.className = 'legend-country-users'
                                users.innerHTML = dp.count
                                item.appendChild(users)

                                // add item to legend
                                legend.appendChild(item)
                            }
                        }.bind(this),
                    },
                ],
            })
        },
    },
} // End of export default
</script>
